/**
 * Labstep
 *
 * @module components/Resource/Form/ResourceTemplate
 * @desc ShowEdit Form for resource template field
 */

import EntityFormShowEditTemplate from 'labstep-web/components/Entity/Form/ShowEdit/Template';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import type { IResourceFormShowEditResourceTemplateProps } from './types';

export const ResourceFormShowEditResourceTemplate: React.FC<
  IResourceFormShowEditResourceTemplateProps
> = ({ resource, ...rest }) => (
  <EntityFormShowEditTemplate
    entity={resource}
    childEntityName={Resource.entityName}
    {...rest}
  />
);
